// apps/client/src/utils/subscription.ts

import { SubscriptionData } from '@fsp/types';
import { apiClient } from './apiClient';

export const fetchSubscription = async (): Promise<SubscriptionData | null> => {
  const organisationId = localStorage.getItem('organisationId') || '';
  if (!organisationId) {
    throw new Error('No organisation selected');
  }

  const response = await apiClient.get(`/organisations/${organisationId}/stripe/subscriptions`);

  if (response.status === 204) {
    return null;
  }

  if (!response.ok) {
    throw new Error('Failed to fetch subscription');
  }

  return response.json();
};

export const cancelSubscription = async (): Promise<void> => {
  const organisationId = localStorage.getItem('organisationId') || '';
  if (!organisationId) {
    throw new Error('No organisation selected');
  }
  const response = await apiClient.delete(`/organisations/${organisationId}/stripe/subscriptions`);

  if (!response.ok) {
    throw new Error('Failed to cancel subscription');
  }
};

export const reactivateSubscription = async (): Promise<void> => {
  const organisationId = localStorage.getItem('organisationId') || '';
  if (!organisationId) {
    throw new Error('No organisation selected');
  }

  const response = await apiClient.put(
    `/organisations/${organisationId}/stripe/subscriptions/reactivate`
  );

  if (!response.ok) {
    throw new Error('Failed to reactivate subscription');
  }
};
